import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import GameView from './pages/GameView';
import AdminUpload from './pages/AdminUpload';
import BulkUpload from './pages/BulkUpload';
import Admin from './pages/Admin';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <header className="header">
          <div className="container">
            <Link to="/" className="logo-link">
              <img 
                src="/xmmbridge-logo.png" 
                alt="XMMBRIDGE" 
                className="header-logo"
              />
            </Link>
            <nav>
              <Link to="/" className="nav-link">Home</Link>
            </nav>
          </div>
        </header>

        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/game/:id" element={<GameView />} />
            <Route path="/admin-old" element={<AdminUpload />} />
            <Route path="/bulk-upload-old" element={<BulkUpload />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
